import { IoIosDesktop } from "react-icons/io";
import { FaMobile, FaCodeBranch } from "react-icons/fa";
import { TbApi } from "react-icons/tb";
import { BiTestTube } from "react-icons/bi";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Project Management",
    des: "You want to gain practical experience in managing a complete software development cycle.",
  },
  {
    id: 2,
    icon: <TbApi />,
    title: "Backend",
    des: "Great experience in the development and use of APIs to connect all your projects to the rest of the world.",
  },
  {
    id: 3,
    icon: <IoIosDesktop />,
    title: "Web",
    des: "Five years of experience in web development. I have developed various website and also hosted them.",
  },
  {
    id: 4,
    icon: <FaMobile />,
    title: "Mobile",
    des: "Five years of experience in mobile development. I have developed various mobile app and also hosted them.",
  },
  {
    id: 5,
    icon: <BiTestTube />,
    title: "Testing",
    des: "Writing unit tests during the development process and including them in deployment processes",
  },
  {
    id: 6,
    icon: <FaCodeBranch />,
    title: "CI/CD Process",
    des: "Having learned for over two years, I am able to set up live or test delivery pipelines",
  },
];
